import { Card, Row, Col, Statistic, Typography } from 'antd';
import { useGetTransactionsPaymentAcc } from 'hooks/useGetPayments';

interface TransactionSummaryProps {
  filterOptions: any;
  t: (key: string) => string;
}

export function TransactionSummary(props: TransactionSummaryProps) {
  const { filterOptions, t } = props;

  const { total_amount, total_count } = useGetTransactionsPaymentAcc(filterOptions, 0, 0, true);

  return (
    <Card
      title={t('managePage.transactionPage.acc.summary')}
      style={{ width: '100%' }}
      size="small"
    >
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Card
            size="small"
            style={{
              textAlign: 'center',
              backgroundColor: '#fff2f0',
              border: '1px solid #ff4d4f',
              padding: '4px'
            }}
            bodyStyle={{ padding: '8px' }}
          >
            <Statistic
              title={t('managePage.transactionPage.acc.totalInvoiced') || 'Total Invoiced'}
              value={total_amount.total_amount_invoiced}
              precision={0}
              formatter={value => value?.toLocaleString()}
              suffix="VND"
              valueStyle={{ fontSize: '16px', color: '#ff4d4f' }}
            />
            <Typography.Text type="secondary" style={{ fontSize: '11px' }}>
              Count: {total_count.total_count_invoiced?.toLocaleString()}
            </Typography.Text>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Card
            size="small"
            style={{
              textAlign: 'center',
              backgroundColor: '#f6ffed',
              border: '1px solid #52c41a',
              padding: '4px'
            }}
            bodyStyle={{ padding: '8px' }}
          >
            <Statistic
              title={t('managePage.transactionPage.acc.totalStayed') || 'Total Stayed'}
              value={total_amount.total_amount_stayed}
              precision={0}
              formatter={value => value?.toLocaleString()}
              suffix="VND"
              valueStyle={{ fontSize: '16px', color: '#52c41a' }}
            />
            <Typography.Text type="secondary" style={{ fontSize: '11px' }}>
              Count: {total_count.total_count_stayed?.toLocaleString()}
            </Typography.Text>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Card
            size="small"
            style={{
              textAlign: 'center',
              backgroundColor: '#fffbf0',
              border: '1px solid #d4af37',
              padding: '4px'
            }}
            bodyStyle={{ padding: '8px' }}
          >
            <Statistic
              title={t('managePage.transactionPage.acc.totalInHouse') || 'Total In House'}
              value={total_amount.total_amount_in_house}
              precision={0}
              formatter={value => value?.toLocaleString()}
              suffix="VND"
              valueStyle={{ fontSize: '16px', color: '#d4af37' }}
            />
            <Typography.Text type="secondary" style={{ fontSize: '11px' }}>
              Count: {total_count.total_count_in_house?.toLocaleString()}
            </Typography.Text>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Card
            size="small"
            style={{
              textAlign: 'center',
              backgroundColor: '#f0f5ff',
              border: '1px solid #1890ff',
              padding: '4px'
            }}
            bodyStyle={{ padding: '8px' }}
          >
            <Statistic
              title={t('managePage.transactionPage.acc.totalDeposit') || 'Total Deposit'}
              value={total_amount.total_amount_deposit}
              precision={0}
              formatter={value => value?.toLocaleString()}
              suffix="VND"
              valueStyle={{ fontSize: '16px', color: '#1890ff' }}
            />
            <Typography.Text type="secondary" style={{ fontSize: '11px' }}>
              Count: {total_count.total_count_deposit?.toLocaleString()}
            </Typography.Text>
          </Card>
        </Col>

        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <Card
            size="small"
            style={{
              textAlign: 'center',
              backgroundColor: '#f9f0ff',
              border: '3px solid #d3adf7',
              padding: '4px',
              boxShadow: '0 4px 8px rgba(114, 46, 209, 0.15)'
            }}
            bodyStyle={{ padding: '8px' }}
          >
            <Statistic
              title={
                <Typography.Title
                  level={5}
                  style={{ margin: 0, color: '#722ed1', fontSize: '12px', fontWeight: 'bold' }}
                >
                  {t('managePage.transactionPage.acc.grandTotal') || 'Grand Total'}
                </Typography.Title>
              }
              value={total_amount.total_amount_total}
              precision={0}
              formatter={value => value?.toLocaleString()}
              suffix="VND"
              valueStyle={{ color: '#722ed1', fontSize: '18px', fontWeight: 'bold' }}
            />
            <Typography.Text strong style={{ color: '#722ed1', fontSize: '11px' }}>
              Total Count: {total_count.total_count_total?.toLocaleString()}
            </Typography.Text>
          </Card>
        </Col>
      </Row>
    </Card>
  );
}
